import { UI } from "../lib/constants/actions";

export const showMessages = (data) => {
    return {
        type: UI.MESSAGE,
        payload: data
    }
}

export const showLoading = (data) => {
    return {
        type: UI.SHOW_LOADING,
        payload: data
    }
}

export const showMainLoading = (data) => {
    return {
        type: UI.SHOW_MAIN_LOADING,
        payload: data
    }
}

export const showGoogleLoading = (data) => {
    return {
        type: UI.SHOW_GOOGLE_LOADING,
        payload: data
    }
}

export const showGoogleGraphLoading = (data) => {
    return {
        type: UI.SHOW_GOOGLE_GRAPH_LOADING,
        payload: data
    }
}

export const selectGroupId = (data) => {
    return {
        type: UI.SELECT_GROUP_ID,
        payload: data
    }
}

export const showTopSearchesLoading = (data) => {
    return {
        type: UI.SHOW_TOP_SEARCHES_LOADING,
        payload: data
    }
}

export const showProfileLoading = (data) => {
    return {
        type: UI.PROFILE_LOADING,
        payload: data
    }
}

export const showFailedUrlLoading = (data) => {
    return {
        type: UI.FAILED_URLS_LOADING,
        payload: data
    }
}

export const showGoogleActiveGraph = (data) => {
    return {
        type: UI.GOOGLE_ACTIVE_GRAPH,
        payload: data
    }
}